import { loadable } from '../../common/utils/lazyLoading';
import ProgramsStructure from './ProgramsStructure';
const ProgramsPage = loadable(() => import('./ProgramsPage'));
export default {
    id: 'programs',
    title: 'Programs',
    icon: 'tree5',
    route: 'programs',
    defaultRoute: 'programs/program-groups',
    group: 'administration',
    subGroup: 'general',
    component: ProgramsPage,
    structure: ProgramsStructure,
};
